import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.7989 24.1395C14.538 24.1395 6.13547 17.4746 4.47947 16.1457L3.67188 15.4915L4.34658 14.6941C4.52035 14.4897 6.02293 12.7008 6.55449 12.1795C6.9736 11.7501 7.29058 11.4537 23.6461 13.4573C39.7666 15.4404 40.3799 15.9004 40.6048 16.0639C41.6985 16.8817 41.8928 19.3146 41.9337 20.3164L41.9745 21.3999L40.891 21.3795C40.8399 21.3795 35.8412 21.2772 32.3248 21.2772C30.5972 21.2772 27.6533 22.0337 24.8115 22.7595C22.0208 23.4648 19.3936 24.1395 17.7989 24.1395ZM6.57495 15.2053C10.4594 18.2617 16.051 22.095 17.7888 22.095C19.1382 22.095 21.755 21.4204 24.2799 20.7764C27.2444 20.0199 30.3212 19.2328 32.3043 19.2328C34.819 19.2328 38.0798 19.2839 39.7767 19.3146C39.6847 18.6195 39.5315 18.0164 39.3884 17.7608C36.5671 16.9941 11.1443 13.8764 7.771 13.8764H7.76076C7.44388 14.2035 6.98384 14.735 6.57495 15.2053Z",
      fill: "#FF212A"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.5677 34.382L17.8281 23.25L19.8113 22.7696L22.0704 31.9184L23.7775 31.4993L21.5183 22.3607L23.5117 21.87L26.2512 33.002L20.5677 34.382Z",
      fill: "#FF212A"
    }, null, -1)
  ])))
}
export default { render: render }